import React from "react";

import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

import { useScrollLock } from "../../hooks/useScrollLock";
import { selectCategories } from "../../store/slices/categoriesSlice";
import { Icon } from "../ReviewCard/styles";

import {
  Author,
  CLoseContainer,
  Close,
  Job,
  Name,
  Overlay,
  Popup,
  ProfileLink,
  Tag,
  Text,
  Title,
} from "./styles";

import type { Review } from "../../types/reviews";

type ReviewPopupProps = {
  visible: boolean;
  onClose: () => void;
  review: Review;
};

export const ReviewPopup: React.FC<ReviewPopupProps> = ({ visible, onClose, review }) => {

  useScrollLock(visible)
  const categories = useSelector(selectCategories);
  const categoryTitle = categories.find(
    (cat) => cat.id === review.product.product_category
  )?.title || "Без категории";

  if (!visible) return null;

  return ReactDOM.createPortal(
    <Overlay>
      <Popup role="dialog" aria-modal="true">
        <CLoseContainer onClick={onClose}>
          <Close />
        </CLoseContainer>
        <Tag>{categoryTitle}</Tag>
        <Title>
          {review.product.title}
        </Title>
        <Text>{review.content}</Text>
        <Author>
          <Name>{review.author}{review.job_title && ", "}</Name>
          <Job>&nbsp;{review.job_title}</Job>
          {review.profile_url && (
            <ProfileLink
              href={review.profile_url}
              target="_blank"
              rel="noopener noreferrer"
            >
                Профиль LinkedIn
              <Icon />
            </ProfileLink>
          )}
        </Author>
      </Popup>
    </Overlay>,
        document.getElementById("overlay-root")!
  );
};

